import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../../../Layouts/Backend';
import AssignedList from './AssignedList';
import UnassignedList from './UnassignedList';
import { Button } from '../../../../UI/Common';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import DeleteRecord from '../../../../UI/DeleteRecord';
import { DialogBox } from '../../../../UI/Modal';

const MaintainDBPage = (props) => {
  const { t } = props;
  const [unassigned, setUnassigned] = React.useState([]);
  const [assigned, setAssigned] = React.useState([]);
  const actionOptions = [
    { label: 'Assign', action: onAssign, disabled: unassigned.length === 0 },
    {
      label: 'Replace',
      action: onReplace,
      disabled: unassigned.length !== 1 || assigned.length !== 1,
    },
    { label: 'Unassign', action: onUnassign, disabled: assigned.length === 0 },
    {
      label: 'Delete',
      action: onDelete,
      disabled: !helper.checkPermission('admin') || unassigned.length === 0,
    },
    {
      label: 'Repurpose',
      action: onRepurpose,
      disabled: unassigned.length + assigned.length !== 1,
    },
  ];
  const onSelectUnassignedSensors = (sensorIds) => {
    setUnassigned(sensorIds);
  };
  const onSelectAssignedSensors = (sensorIds) => {
    setAssigned(sensorIds);
  };
  function onAssign() {
    props.onAssign(unassigned);
  }
  function onReplace() {
    props.onReplace(assigned, unassigned);
  }
  function onUnassign() {
    props.onUnassign(assigned);
  }
  function onDelete() {
    props.onDelete(unassigned);
  }
  function onRepurpose() {
    props.onRepurpose(assigned.length === 1 ? assigned : unassigned);
  }
  const [openModal, setOpenModal] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openRepurposeModal, setOpenRepurposeModal] = React.useState(false);
  const [act, setAct] = React.useState(null);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onClick(action, type) {
    if (type === 'Delete') {
      setOpenDeleteModal(true);
      setAct(() => () => action());
    } else if (type === 'Repurpose') {
      setOpenRepurposeModal(true);
      setAct(() => () => action());
    } else {
      if (isRequireConfirmation) {
        setOpenModal(true);
        setAct(() => () => action());
      } else {
        action();
      }
    }
  }
  if (Object.keys(props.getGroupError).length) {
    return (
      <Backend>
        <div className="content-inner">This group is unavailable</div>
      </Backend>
    );
  }
  return (
    <Backend>
      <div className="content-inner">
        <DialogBox
          isOpen={openRepurposeModal}
          title={t('Repurpose Sensor')}
          body={t(
            'Are you sure you want to repurpose sensor?  This operation is not reversible.',
          )}
          onCancel={() => {
            setOpenRepurposeModal(false);
            setAct(null);
          }}
          onYes={() => {
            setOpenRepurposeModal(false);
            act();
            setAct(null);
          }}
        />
        <DeleteRecord
          isOpen={openDeleteModal}
          title="Delete sensor"
          body="Are you sure you want to delete this sensor?"
          onCancel={() => {
            setOpenDeleteModal(false);
            setAct(null);
          }}
          onConfirm={() => {
            setOpenDeleteModal(false);
            act();
            setAct(null);
          }}
        />
        <PasswordConfirmation
          isOpen={openModal}
          onCancel={() => {
            setOpenModal(false);
            setAct(null);
          }}
          onConfirm={() => {
            setOpenModal(false);
            act();
            setAct(null);
          }}
        />
        <h1>Assignments for Group: {props.group.name}</h1>
        <UnassignedList
          onSelectUnassignedSensors={onSelectUnassignedSensors}
          {...props}
        />
        <h1>{t('Assigned List')}</h1>
        <div>
          {actionOptions.map((act, index) => {
            return (
              <Button
                key={index}
                classes="mr-10 mb-10"
                disabled={act.disabled}
                onClick={() => onClick(act.action, act.label)}
              >
                {t(act.label)}
              </Button>
            );
          })}
        </div>
        <AssignedList
          onSelectAssignedSensors={onSelectAssignedSensors}
          {...props}
        />
      </div>
    </Backend>
  );
};

export default withTranslation('app')(MaintainDBPage);
